/* istanbul ignore file */
import * as React from 'react'

function IconPeopleAndCulture({
  srText,
  size = 'md',
  className = '',
  ...props
}) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`
  return (
    <>
      {!!srText && <span className='mc-sr-only'>{srText}</span>}
      <svg
        width={25}
        height={25}
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 24 24'
        aria-hidden='true'
        role='img'
        className={newClassName}
        {...props}
      >
        <path
          d='M14 12h-3M15.5 6.5a3.09 3.09 0 0 0-3-3 3.089 3.089 0 0 0-3 3A2.941 2.941 0 0 0 11 9v1h3V9a2.943 2.943 0 0 0 1.5-2.5v0ZM4.5 20.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM8 24a3.612 3.612 0 0 0-7 0h7ZM12.5 20.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM16 24a3.612 3.612 0 0 0-7 0h7ZM20.5 20.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM24 24a3.612 3.612 0 0 0-7 0h7ZM12.5 1v1M16.389 2.611l-.707.707M18 6h-1M8.611 2.611l.707.707M7 6h1M11.5 14h2'
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </>
  )
}

export default IconPeopleAndCulture
